export const SYNC_LOCK_ID = "sync-lock";

export const BOOTSTRAP_HEARTBEAT_INTERVAL = 1000;
export const LOGOUT_HEARTBEAT_INTERVAL = 1000;

export const BOOTSTRAP_TIMEOUT = 2500;
export const LOGOUT_TIMEOUT = 2500;
